import { Store } from '@ngxs/store';
import { ConfigState, UserState } from '../../state';
import { ErrorHandler, Injectable, Injector, inject } from '@angular/core';
import { captureException, setExtra, setUser, showReportDialog, User } from '@sentry/angular';
import { AppState, ErrorHandlerConfig } from '../../../model';

@Injectable()
export class GlobalErrorHandlerService implements ErrorHandler {
  private readonly injector = inject(Injector);

  handleError(error: any): void {
    console.error('Error thrown', error);
    const store = this.injector.get(Store);
    const user = store.selectSignal(UserState.user);
    let userDetails: User;
    if (user()) {
      userDetails = {
        name: `${user().given_name} ${user().family_name}`,
        email: user().email,
      };
    }
    // Filter out the states so that the bulkier states are removed to prevent reaching the max character cap for an API
    setExtra(
      'state',
      store.selectSnapshot((state: AppState) => {
        const stateValue = {};
        const statesToLog = store.selectSnapshot<ErrorHandlerConfig>(ConfigState.errorHandlerConfigs)?.statesToLog;
        statesToLog?.forEach(stateName => {
          stateValue[stateName] = state[stateName];
        });
        return stateValue;
      })
    );
    setUser(userDetails);
    const eventId = captureException(error.originalError ?? error);
    showReportDialog({
      eventId,
      lang: 'en',
      subtitle: 'Please help us to improve the Dictionary Service by providing additional data.',
      subtitle2: 'Your data will be used for investigation by Akelius IT only.',
      user: userDetails,
    });
  }
}
